document.addEventListener("DOMContentLoaded", function () {
  var fabricPopup = document.getElementById("fabric-popup");
  var closePopup = document.getElementById("close-popup");
  var fabricSwatches = document.querySelectorAll(".fabric-swatch-button");
  var confirmButton = document.getElementById("confirm-selection");
  var fabricSelect = document.querySelector(".js-variant-selector");
  var selectedFabricName = document.getElementById("selected-fabric-name");
  var selectedFabricMaterial = document.getElementById(
    "selected-fabric-material"
  );
  var selectedFabricImage = document.getElementById("selected-fabric-image");
  var selectedFabricPrice = document.getElementById("selected-fabric-price");
  var currentSelectedFabric = "";
  var previousSelectedSwatch = null;
  var productData = null;
  var hasSelectionBeenMade = false;
  var isSelectionConfirmed = false;

  // Disable the confirm button by default
  confirmButton ? confirmButton.setAttribute("disabled", true) : null;

  function disableScrolling() {
    document.body.style.overflow = "hidden";
  }

  function enableScrolling() {
    document.body.style.overflow = "auto";
  }

  async function fetchProductData(path) {
    try {
      const response = await fetch(path);
      return await response.json();
    } catch (error) {
      console.error("Error loading product data:", error);
    }
  }

  function setFabricPrice(fabricValue) {
    if (productData) {
      const variant = productData.product.variants.find(function (variant) {
        // in some cases the material in the CMS and variant select menu don't match exactly so just try and match on the fabric name
        const fabricOptionName = variant.option1.split(" - ")?.[0];
        const incomingFabricName = fabricValue.split(" - ")?.[0];
        if (fabricOptionName.length === 0 || incomingFabricName.length === 0) {
          console.log("Zero length name detected (setFabricPrice)");
          return false;
        }
        return fabricOptionName === incomingFabricName;
      });
      if (variant) {
        selectedFabricPrice.innerHTML = `<span class="label">Price:</span> <strong>£${variant.price}</strong>`;
      } else {
        selectedFabricPrice.innerHTML = "";
      }
    }
  }

  function handleSwatchClick(swatch) {
    var fabricName = swatch.getAttribute("data-name");
    var fabricMaterial = swatch.getAttribute("data-material") || "";
    var fabricImage = swatch.getAttribute("data-image");

    var nameParts = fabricName.split(": ");
    var grade = nameParts[0];
    var name = nameParts[1];

    selectedFabricName.innerHTML = `<span class="label">${grade}</span> <strong>${name}</strong>`;
    selectedFabricMaterial.innerHTML = fabricMaterial
      ? `${fabricMaterial}`
      : "";
    selectedFabricImage.innerHTML =
      '<img src="' + fabricImage + '" alt="' + name + '" width="300">';

    setFabricPrice(swatch.getAttribute("data-fabric"));

    currentSelectedFabric = swatch.getAttribute("data-fabric");

    if (previousSelectedSwatch) {
      previousSelectedSwatch.classList.remove("selected");
    }
    swatch.classList.add("selected");
    previousSelectedSwatch = swatch;

    // Enable and animate the confirm button
    confirmButton.removeAttribute("disabled");
    confirmButton.classList.add("animate");
    setTimeout(() => {
      confirmButton.classList.remove("animate");
    }, 500);

    // Update selection state
    hasSelectionBeenMade = true;
    isSelectionConfirmed = false;
  }

  async function initializeSelectedFabric() {
    var productPath = window.location.pathname + ".json";
    productData = await fetchProductData(productPath);

    var initialFabricValue = fabricSelect.value;

    // Extract the fabric name part before the dash from the select value
    var initialFabricNamePart = initialFabricValue.split(" - ")[0].trim();

    var initialFabricSwatch = Array.from(fabricSwatches).find(function (
      swatch
    ) {
      // Extract the fabric name part before the dash from the swatch
      var swatchFabricName = swatch
        .getAttribute("data-fabric")
        .split(" - ")[0]
        .trim();

      // Compare only the part before the dash
      return swatchFabricName === initialFabricNamePart;
    });

    if (initialFabricSwatch) {
      var fabricName = initialFabricSwatch.getAttribute("data-name");
      var fabricMaterial =
        initialFabricSwatch.getAttribute("data-material") || "";
      var fabricImage = initialFabricSwatch.getAttribute("data-image");

      var nameParts = fabricName.split(": ");
      var grade = nameParts[0];
      var name = nameParts[1];

      selectedFabricName.innerHTML = `<span class="label">${grade}:</span> <strong>${name}</strong>`;
      selectedFabricMaterial.innerHTML = fabricMaterial
        ? `<span class="label">Detail:</span> <strong>${fabricMaterial}</strong>`
        : "";
      selectedFabricImage.innerHTML =
        '<img src="' + fabricImage + '" alt="' + name + '" width="300">';

      setFabricPrice(initialFabricSwatch.getAttribute("data-fabric"));

      // Ensure the selected class is applied based only on the fabric name
      currentSelectedFabric = initialFabricSwatch
        .getAttribute("data-fabric")
        .split(" - ")[0]
        .trim();

      // Remove selected class from the previous swatch if it exists
      if (previousSelectedSwatch) {
        previousSelectedSwatch.classList.remove("selected");
      }

      initialFabricSwatch.classList.add("selected");
      previousSelectedSwatch = initialFabricSwatch;

      // Set initial state
      hasSelectionBeenMade = false;
      isSelectionConfirmed = false;
    }
  }

  async function openFabricPopup() {
    fabricPopup.style.display = "block";
    disableScrolling();

    // Clear previous selections
    fabricSwatches.forEach(function (swatch) {
      swatch.classList.remove("selected");
    });

    // Load JSON data when the popup is opened
    if (!productData) {
      await initializeSelectedFabric();
    } else {
      var initialFabricValue = fabricSelect.value;

      // Extract the fabric name part before the dash from the select value
      var initialFabricNamePart = initialFabricValue.split(" - ")[0].trim();

      var initialFabricSwatch = Array.from(fabricSwatches).find(function (
        swatch
      ) {
        // Extract the fabric name part before the dash from the swatch
        var swatchFabricName = swatch
          .getAttribute("data-fabric")
          .split(" - ")[0]
          .trim();

        // Compare only the part before the dash
        return swatchFabricName === initialFabricNamePart;
      });

      if (initialFabricSwatch) {
        var fabricName = initialFabricSwatch.getAttribute("data-name");
        var fabricMaterial =
          initialFabricSwatch.getAttribute("data-material") || "";
        var fabricImage = initialFabricSwatch.getAttribute("data-image");

        var nameParts = fabricName.split(": ");
        var grade = nameParts[0];
        var name = nameParts[1];

        selectedFabricName.innerHTML = `<span class="label">${grade}:</span> <strong>${name}</strong>`;
        selectedFabricMaterial.innerHTML = fabricMaterial
          ? `<span class="label">Detail:</span> <strong>${fabricMaterial}</strong>`
          : "";
        selectedFabricImage.innerHTML =
          '<img src="' + fabricImage + '" alt="' + name + '" width="300">';

        setFabricPrice(initialFabricSwatch.getAttribute("data-fabric"));

        // Ensure the selected class is applied based only on the fabric name
        currentSelectedFabric = initialFabricSwatch
          .getAttribute("data-fabric")
          .split(" - ")[0]
          .trim();

        initialFabricSwatch.classList.add("selected");
        previousSelectedSwatch = initialFabricSwatch;

        // Set initial state
        hasSelectionBeenMade = false;
        isSelectionConfirmed = false;
      }
    }
  }

  const viewFabricsBtn = document.getElementById("view-fabrics-btn");

  if (viewFabricsBtn) {
    viewFabricsBtn.addEventListener("click", openFabricPopup);
  }

  closePopup.addEventListener("click", function () {
    fabricPopup.style.display = "none";
    enableScrolling();
    // Reset the confirm button and selection state
    confirmButton.setAttribute("disabled", true);
    hasSelectionBeenMade = false;
    isSelectionConfirmed = false;
  });

  window.addEventListener("click", function (event) {
    if (event.target === fabricPopup) {
      if (hasSelectionBeenMade && !isSelectionConfirmed) {
        event.stopPropagation();
      } else {
        fabricPopup.style.display = "none";
        enableScrolling();
      }
    }
  });

  fabricSwatches.forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      handleSwatchClick(swatch);
    });
  });

  confirmButton
    ? confirmButton.addEventListener("click", function () {
        if (currentSelectedFabric) {
          // Split the selected fabric at the dash and trim any whitespace
          const selectedFabricName = currentSelectedFabric
            .split(" - ")[0]
            .trim();

          // Get the select element
          const fabricSelect = document.querySelector(
            'select.js-variant-selector[name*="Fabric"]'
          );

          // Find the option that matches the selected fabric name (ignoring text after the dash)
          const matchingOption = Array.from(fabricSelect.options).find(
            (option) => {
              // Compare only the part before the dash in each option
              const optionFabricName = option.value.split(" - ")[0].trim();
              return optionFabricName === selectedFabricName;
            }
          );

          if (matchingOption) {
            fabricSelect.value = matchingOption.value;
            // Dispatch change event
            var event = new Event("change", { bubbles: true });
            fabricSelect.dispatchEvent(event);

            // Hide popup and enable scrolling
            fabricPopup.style.display = "none";
            enableScrolling();
            isSelectionConfirmed = true;
          } else {
            console.log("No matching fabric found for:", currentSelectedFabric);
          }
        }
      })
    : null;

  // Initialize the selected fabric details on page load
  initializeSelectedFabric();
});
